module.exports = __webpack_public_path__ + "static/media/boatIcon.625a1e60.png";